<template>
  <div class="is-height-100p">
    <div>
      <AppHeader :urlLogoSociete="urlLogoSociete"/>
    </div>
    <b-autocomplete
      v-model="search"
      :data="filtreRecoms"
      placeholder="Recherche un point de vente"
      icon="magnify"
      clearable
      field="libelle"
      @select="accessRecomPdv($event)">
      <template slot="empty">Aucune recommandation trouvée</template>
    </b-autocomplete>
    <CartoGeneral :pointDeVentes="pdvFilter" :panneaux="panneauxFilter"/>
    <ListeEnseigne
      v-if="typeClient === constants.GROUPE && currentTypeClient === constants.GROUPE"
      :recoms="recomsFilter"
      :enseignes="enseignes"
      @go-to-list-enseigne="goToListEnseigne"/>
    <ListePointDeVente
      v-if="isEnseigne"
      :recoms="recomsFilter"
      :enseignes="enseignesFilter"
      :pdVentes="pdvFilter"
      :typeClient="typeClient"
      @back="currentTypeClient = constants.GROUPE"/>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import gestionErreur from '@/services/general/gestionErreur';
import Header from '@/components/general/Header';
import CartoGeneral from '@/components/portailGroupe/CartoGeneralPortail';
import ListeEnseigne from '@/components/portailGroupe/ListeEnseigne';
import ListePointDeVente from '@/components/portailGroupe/ListePointDeVente';
import { GROUPE, ENSEIGNE } from '@/configurations/clientConf';
import { getRecomClientAsync } from '@/api/recom/recom_gescom';
import { mapRecommandationsClient, mapPointsDeVente, mapPanneaux } from '@/services/recommandation/portailClientMapping';
import { getIconPdvData } from '@/services/gestionIconMarker/iconColorGetter';
import { formatNombre } from '@/services/general/general';

export default {
  components: {
    AppHeader: Header,
    CartoGeneral,
    ListeEnseigne,
    ListePointDeVente,
  },
  data: () => ({
    search: '',
    recoms: [],
    typeClient: '',
    currentTypeClient: '',
    idClient: '',
    pdv: [],
    panneaux: [],
    enseignes: [],
    urlLogoSociete: '',
    constants: {
      GROUPE,
      ENSEIGNE,
    },
  }),
  computed: {
    isEnseigne() {
      return this.currentTypeClient === ENSEIGNE;
    },
    recomsFilter() {
      if (this.isEnseigne) {
        return this.recoms.filter(recom => recom.idEnseigne === this.idClient);
      }
      return this.recoms;
    },
    filtreRecoms() {
      return this.recomsFilter
        .map(recom => ({
          libelle: `${recom.pointDeVente.nomCommercial} - ${formatNombre(recom.montant)}`,
          previewLink: recom.previewLink,
        }))
        .filter((pdv) => {
          return pdv.libelle
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) >= 0
        });
    },
    pdvFilter() {
      if (this.isEnseigne) {
        return this.pdv.filter(p => p.idEnseigne === this.idClient);
      }
      return this.pdv;
    },
    panneauxFilter() {
      if (this.isEnseigne) {
        return this.panneaux.filter(p => p.idEnseigne === this.idClient);
      }
      return this.panneaux;
    },
    enseignesFilter() {
      if (this.isEnseigne) {
        return this.enseignes.filter(p => p.id === this.idClient);
      }
      return this.enseignes;
    }
  },
  methods: {
    async load() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const res = (await getRecomClientAsync(this.$route.query.hash)).data.result;
        this.recoms = mapRecommandationsClient(res.recommandations || []);
        this.typeClient = this.currentTypeClient = res.typeClient;
        this.idClient = res.idClient;
        this.enseignes = res.enseignes || [];
        this.urlLogoSociete = res.societe ? res.societe.chemin : '';
        await this.genererPointDeVente();
        this.genererPanneaux();
      } catch (e) {
        gestionErreur('Erreur serveur');
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    accessRecomPdv(data) {
      window.open(data.previewLink);
    },
    async genererPointDeVente() {
      const pdv = mapPointsDeVente(this.recoms);
      const icons = new Map(
        await Promise.all(
          uniqBy(pdv, 'id').map(async el => {
            const url = el.srcImg && el.srcImg.includes('https://') ? el.srcImg : null;
            const { icon } = await getIconPdvData(url);
            return [el.id, icon];
          })
        )
      );
      pdv.forEach(el => {
        if (icons.has(el.id)) el.icon = icons.get(el.id);
      });
      this.pdv = pdv;
    },
    genererPanneaux() {
      this.panneaux = mapPanneaux(this.recoms);
    },
    goToListEnseigne(idEnseigne) {
      this.idClient = idEnseigne;
      this.currentTypeClient = this.constants.ENSEIGNE;
    }
  },
  async mounted() {
    await this.$gmapApiPromiseLazy();
    await this.load();
  },
}
</script>
